var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPasswordLock = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 564.99 447.86",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.56,133.09H151.43c-14.51,0-26.28,11.77-26.28,26.28v206.06c0,14.51,11.77,26.28,26.28,26.28h262.13c14.51,0,26.28-11.77,26.28-26.28v-206.06c0-14.51-11.77-26.28-26.28-26.28ZM303.22,254.56v57.25c0,11.44-9.28,20.72-20.72,20.72s-20.72-9.28-20.72-20.72v-57.25c-8.42-6.31-13.87-16.37-13.87-27.7,0-19.11,15.49-34.6,34.6-34.6s34.6,15.49,34.6,34.6c0,11.33-5.45,21.39-13.87,27.7Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.53,133.09v-24.95c0-37.47,30.49-67.96,67.96-67.96s67.96,30.49,67.96,67.96v24.95h40.17v-24.95c0-59.72-48.41-108.13-108.13-108.13h0c-59.72,0-108.13,48.41-108.13,108.13v24.95h40.17Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 295.26,
    width: 540.99,
    height: 140.6,
    rx: 25.22,
    ry: 25.22,
    style: {
      fill: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.36,365.56l13.99-13.99c3.41-3.41,3.41-8.93,0-12.33-3.41-3.41-8.93-3.41-12.33,0l-5.27,5.27v-7.45c0-4.82-3.9-8.72-8.72-8.72s-8.72,3.9-8.72,8.72v7.45l-5.27-5.27c-3.41-3.41-8.93-3.41-12.33,0s-3.41,8.93,0,12.33l13.99,13.99-13.99,13.99c-3.41,3.41-3.41,8.93,0,12.33s8.93,3.41,12.33,0l5.27-5.27v7.45c0,4.82,3.9,8.72,8.72,8.72s8.72-3.9,8.72-8.72v-7.45l5.27,5.27c3.41,3.41,8.93,3.41,12.33,0,3.41-3.41,3.41-8.93,0-12.33l-13.99-13.99Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.67,365.56l13.99-13.99c3.41-3.41,3.41-8.93,0-12.33-3.41-3.41-8.93-3.41-12.33,0l-5.27,5.27v-7.45c0-4.82-3.9-8.72-8.72-8.72s-8.72,3.9-8.72,8.72v7.45l-5.27-5.27c-3.41-3.41-8.93-3.41-12.33,0s-3.41,8.93,0,12.33l13.99,13.99-13.99,13.99c-3.41,3.41-3.41,8.93,0,12.33s8.93,3.41,12.33,0l5.27-5.27v7.45c0,4.82,3.9,8.72,8.72,8.72s8.72-3.9,8.72-8.72v-7.45l5.27,5.27c3.41,3.41,8.93,3.41,12.33,0,3.41-3.41,3.41-8.93,0-12.33l-13.99-13.99Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.98,365.56l13.99-13.99c3.41-3.41,3.41-8.93,0-12.33-3.41-3.41-8.93-3.41-12.33,0l-5.27,5.27v-7.45c0-4.82-3.9-8.72-8.72-8.72s-8.72,3.9-8.72,8.72v7.45l-5.27-5.27c-3.41-3.41-8.93-3.41-12.33,0-3.41,3.41-3.41,8.93,0,12.33l13.99,13.99-13.99,13.99c-3.41,3.41-3.41,8.93,0,12.33,3.41,3.41,8.93,3.41,12.33,0l5.27-5.27v7.45c0,4.82,3.9,8.72,8.72,8.72s8.72-3.9,8.72-8.72v-7.45l5.27,5.27c3.41,3.41,8.93,3.41,12.33,0,3.41-3.41,3.41-8.93,0-12.33l-13.99-13.99Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.47,365.56l13.37-13.37c3.25-3.25,3.25-8.53,0-11.79-3.25-3.25-8.53-3.25-11.79,0l-5.03,5.03v-7.12c0-4.6-3.73-8.33-8.33-8.33s-8.33,3.73-8.33,8.33v7.12l-5.04-5.04c-3.25-3.25-8.53-3.25-11.79,0-3.25,3.25-3.25,8.53,0,11.79l13.37,13.37-13.37,13.37c-3.25,3.25-3.25,8.53,0,11.79,3.25,3.25,8.53,3.25,11.79,0l5.04-5.04v7.12c0,4.6,3.73,8.33,8.33,8.33s8.33-3.73,8.33-8.33v-7.12l5.03,5.03c3.25,3.25,8.53,3.25,11.79,0,3.25-3.25,3.25-8.53,0-11.79l-13.37-13.37Z",
    style: {
      fillRule: "evenodd"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.71,
    y: 328.34,
    width: 16.62,
    height: 74.44,
    rx: 8.31,
    ry: 8.31,
    transform: "translate(449.59 281.54) rotate(90)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 208.03,
    y: 328.34,
    width: 16.62,
    height: 74.44,
    rx: 8.31,
    ry: 8.31,
    transform: "translate(581.9 149.23) rotate(90)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 340.34,
    y: 328.34,
    width: 16.62,
    height: 74.44,
    rx: 8.31,
    ry: 8.31,
    transform: "translate(714.21 16.91) rotate(90)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 472.65,
    y: 328.34,
    width: 16.62,
    height: 74.44,
    rx: 8.31,
    ry: 8.31,
    transform: "translate(846.53 -115.4) rotate(90)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPasswordLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/password_lock.7745b2fc.svg";
export { ForwardRef as ReactComponent };